$(document).ready(function () {
    $('.hamburger').click(function (e) {
        e.preventDefault();


        if($(this).attr('aria-expanded') === 'true') {
            $(this).addClass('is-active');
            $('.backdrop').addClass('backdrop--active');
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.width = '100vw';
            document.body.style.top = `-${scrollY}px`;
        } else {
            $(this).removeClass('is-active');
            $('.backdrop').removeClass('backdrop--active');
            const scrollY= document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo({left: 0, top: parseInt(scrollY || '0') * -1, behavior: "instant"});
        }
    });

    const swiper = new Swiper('.news-swiper', {
        speed: 400, spaceBetween: 100, slidesPerView: 1, // Responsive breakpoints

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // xs: 0,
        // sm: 576px,
        // md: 768px,
        // lg: 992px,
        // xl: 1200px,
        // xxl: 1400px
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1, spaceBetween: 20
            }, // when window width is >= 480px
            768: {
                slidesPerView: 2, spaceBetween: 40
            }, // when window width is >= 640px
            992: {
                slidesPerView: 3, spaceBetween: 60
            }
        }
    });

    const publicationSwiper = new Swiper('.publication-swiper', {
        speed: 400, spaceBetween: 100, slidesPerView: 1, // Responsive breakpoints

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoHeight: true,
        // xs: 0,
        // sm: 576px,
        // md: 768px,
        // lg: 992px,
        // xl: 1200px,
        // xxl: 1400px
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1, spaceBetween: 20
            }, // when window width is >= 480px
            768: {
                slidesPerView: 1, spaceBetween: 40
            }, // when window width is >= 640px
            992: {
                slidesPerView: 1, spaceBetween: 60
            }
        }
    });

    Fancybox.bind("[data-fancybox]", {
        hideScrollbar: false,
        l10n: Fancybox.l10n.de,
    });

    const newsdetailSwiper = new Swiper('.news-detail-swiper', {
        speed: 400, spaceBetween: 100, slidesPerView: 1, // Responsive breakpoints

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoHeight: true,
        // xs: 0,
        // sm: 576px,
        // md: 768px,
        // lg: 992px,
        // xl: 1200px,
        // xxl: 1400px
        breakpoints: {
            // when window width is >= 320px
            576: {
                slidesPerView: 2, spaceBetween: 20
            }, // when window width is >= 480px
            768: {
                slidesPerView: 1, spaceBetween: 40
            }, // when window width is >= 640px
            992: {
                slidesPerView: 1, spaceBetween: 60
            }
        }
    });

    $('.swiper.outflow-wrapper .swiper-button-next').each(function() {
        // move the button outside the wrapper
        $(this).appendTo($(this).parent().parent());
    });


    Fancybox.bind("[data-fancybox]", {
        hideScrollbar: false,
        l10n: Fancybox.l10n.de,
    });
});

const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();

